import { gql } from '@apollo/client';

export const WORKPLACES = gql`
	query Workplaces($fulltext: String, $type: String) {
		workplaces(fulltext: $fulltext, type: $type) {
			data {
				__typename
				id
				name
				fullName
				internalName
				doctorDisplayName
			}
		}
	}
`;
